/*
 *		Copyright (c) 2011-2017 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.OfficeOnline')
    .directive('accOfficeOnlineFullscreen', [
        'Favicon', 'template', '$animate', '$location', 'OfficeOnline', 'FileTypeIcons', 'FileExtension', 'relativeUrlRootFilter',
        function (Favicon, template, $animate, $location, OfficeOnline, FileTypeIcons, FileExtension, relativeUrlRootFilter) {
            return {
                scope: true,
                templateUrl: template('nodes/office_online_fullscreen'),
                link: function ($scope, $element) {
                    let iframe = $element.find('iframe');

                    iframe.on('load', function () {
                        Favicon.setUrl(_getFileTypeIcon($scope.file.name));
                        $scope.$apply();
                    });

                    $location.search(OfficeOnline.getUrlQueryParamName(), $scope.action);

                    $scope.$on('$routeChangeSuccess', _handleRouteChange);
                    $scope.$on('$routeUpdate', _handleRouteChange);

                    function _handleRouteChange() {
                        if ($location.search()[OfficeOnline.getUrlQueryParamName()]) return;

                        OfficeOnline.setClosed();
                        Favicon.revertOriginalUrl();
                        $animate.leave(iframe).then(function () {
                            $scope.$destroy();
                            $element.remove();
                        });
                    }

                    function _getFileTypeIcon(filename) {
                        let iconName = FileTypeIcons[FileExtension.getExtension(filename)] || FileTypeIcons.file;

                        return relativeUrlRootFilter(`/images/file_types/client/${iconName}.svg`);
                    }
                }
            }
        }
    ]);
